// La marca del NEGOCIO ACTIVO dentro del panel. Por defecto el panel lleva la
// de VX AI; un cliente con marca propia entra aquí por su `slug` (el de
// `chatai.tenants`) y el marco le pinta su logo, con «VX AI» discreto al pie.
//
// ⚠️ Es solo presentación: quién ve qué negocio lo decide la RLS, no esto.
// ⚠️ El login NO pasa por aquí: antes de entrar el panel no sabe quién viene.
//
// Para sumar un cliente: su imagen en `web/public/marcas/<slug>.png` (cuadrada,
// fondo transparente) y una línea en `MARCAS`.
export interface Marca { logo: string; alt: string }

const MARCAS: Record<string, Marca> = {
  "colegio-engativa": {
    logo: "/marcas/colegio-engativa.png",
    alt: "Escudo del Colegio Mayor de Engativá",
  },
};

export function marcaDe(slug: string | null | undefined): Marca | null {
  // `hasOwn`: `MARCAS` es un objeto, y un slug como "constructor" no es marca.
  return slug && Object.hasOwn(MARCAS, slug) ? MARCAS[slug] : null;
}

const FAVICON_VXAI = "/favicon.svg";

// La pestaña del navegador sigue al negocio activo (y vuelve a VX AI al cambiar
// a uno sin marca propia o al salir).
export function aplicarFavicon(marca: Marca | null) {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) return;
  link.type = marca ? "image/png" : "image/svg+xml";
  link.href = marca ? marca.logo : FAVICON_VXAI;
}
